import { render } from "./ModuleContentComponent.vue?vue&type=template&id=63cd22ea&scoped=true"
import script from "./ModuleContentComponent.vue?vue&type=script&lang=js"
export * from "./ModuleContentComponent.vue?vue&type=script&lang=js"

import "./ModuleContentComponent.vue?vue&type=style&index=0&id=63cd22ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63cd22ea"]])

export default __exports__